import { ApiResponse } from "@api/apiRequest";
import { paymentGatewayApi } from "@api/instances";
import rollbar, { LogMetadata } from "@utils/rollbar";

export interface CancelStripeSubscriptionResponse {
  message: string;
}

const cancelStripeSubscription = async (
  subscriptionId: string
): Promise<ApiResponse<CancelStripeSubscriptionResponse>> => {
  const endpoint = `/v1/subscriptions/cancel/${subscriptionId}`;
  try {
    const response = await paymentGatewayApi.delete(
      endpoint,
      { requireAuth: true }
    );
    return { data: { message: response.data?.message ?? "" }, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint, method: "DELETE" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error cancelling subscription" };
  }
};

export default cancelStripeSubscription;
